(function() {
    'use strict';

    angular.module('user')
        .controller('AllowedIpUpdateController', AllowedIpUpdateController);

    AllowedIpUpdateController.$inject = ['$state', 'allowedIpDataSrvc', 'notificationSrvc', 'allowedIpMessagesConst'];

    function AllowedIpUpdateController($state, allowedIpDataSrvc, notificationSrvc, allowedIpMessagesConst) {
        var self = this;

        self.serverErrors = {
            ip: [],
            description: [],
            nonFieldErrors: []
        };
        self.allowedIpData = {
            ip: '',
            description: '',
        };

        self.updateAllowedIp = updateAllowedIp;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getAllowedIp();
        }

        function getAllowedIp() {
            return allowedIpDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(
                function(response) {
                    self.allowedIpData = response;
                }
            );
        }

        function updateAllowedIp() {
            allowedIpDataSrvc.update({
                pk: self.allowedIpData.pk
            }, self.allowedIpData).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", allowedIpMessagesConst.update);
                    $state.go('layout.allowedIp.list');
                },
                function(response) {
                    notificationSrvc.notification("success", allowedIpMessagesConst.error);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(errorField, key) {
            errorField[key] = [];
        }
    }
})();
